/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon20Solid = forwardRef('ArrowADownRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.482 14.25H5.5a1.25 1.25 0 1 0 0 2.5H14A2.75 2.75 0 0 0 16.75 14V5.5a1.25 1.25 0 1 0-2.5 0v6.982L4.884 3.116a1.25 1.25 0 1 0-1.768 1.768l9.366 9.366Z" })));
});
